import { useSlate } from "slate-react";

import { HEADING_TYPES, TextAction, CustomElement, HeadingKey, TextFormatKey } from "./types";
import { findSelectedText, getBlockSelectionProps, getMarkSelectionProps, toggleBlock, toggleMark } from "./utils/transforms";
import { Divider } from "./Divider";
import { IconButton } from "../widgets/IconButton";
import { Flex } from "../widgets/Flex";
import { Box } from "../widgets/Box";
import { Selector } from "../widgets/Selector";
import { Tooltip } from "../widgets/Tooltip";
import { FileUploader } from "../widgets/FileUploader";
import { useEffect, useState } from "react";
import { Transforms } from "slate";
import { LinkMaker } from "./LinkMaker";

import {
  Code,
  Highlighter,
  Image,
  Justify,
  JustifyLeft,
  JustifyRight,
  Link,
  ListOl,
  ListUl,
  Quote,
  Subscript,
  Superscript,
  TextCenter,
  TypeBold,
  TypeItalic,
  TypeStrikethrough,
  TypeUnderline,
} from 'react-bootstrap-icons';

export const INSERT_IMAGE_BLOCK = {id: TextAction.Image, icon: <Image />, label: 'Insert image'}

export const INSERT_LINK_BLOCK = {id: TextAction.Link, icon: <Link />, label: 'Insert link'}

export const TEXT_FORMAT_OPTIONS = [
  { id: TextAction.Bold, icon: <TypeBold />, label: 'Bold' },
  { id: TextAction.Italics, icon: <TypeItalic />, label: 'Italics' },
  { id: TextAction.Underline, icon: <TypeUnderline />, label: 'Underline' },
  {
    id: TextAction.Highlight,
    icon: <Highlighter />,
    label: 'Highlight',
    fontSize: '10px',
  },
  {
    id: TextAction.Strikethrough,
    icon: <TypeStrikethrough />,
    label: 'Strikethrough',
  },
  {
    id: TextAction.Superscript,
    icon: <Superscript />,
    label: 'Superscript',
  },
  {
    id: TextAction.Subscript,
    icon: <Subscript />,
    label: 'Subscript',
  },
  {
    id: TextAction.Code,
    icon: <Code />,
    label: 'Code',
  },
];

export const TEXT_BLOCK_OPTIONS = [
  {
    id: TextAction.LeftAlign,
    icon: <JustifyLeft />,
    label: 'Align Left',
  },
  {
    id: TextAction.CenterAlign,
    icon: <TextCenter />,
    label: 'Align Center',
  },
  {
    id: TextAction.RightAlign,
    icon: <JustifyRight />,
    label: 'Align Right',
  },
  {
    id: TextAction.JustifyAlign,
    icon: <Justify />,
    label: 'Align Justify',
  },
  {
    id: TextAction.BlockQuote,
    icon: <Quote />,
    label: 'Block Quote',
  },
  {
    id: TextAction.BulletedList,
    icon: <ListUl />,
    label: 'Bulleted List',
  },
  {
    id: TextAction.NumberedList,
    icon: <ListOl />,
    label: 'Numbered List',
  },
];





export const Toolbar = () => {

  const [openFileDialogue, setOpenFileDialogue] = useState(false);
  const [selectedFile, setSelectedFile] = useState<string>('');
  const [openLinkDialogue, setOpenLinkDialogue] = useState(false);
  const [selectedText, setSelectedText] = useState<string>('');

  const editor = useSlate();

  let selectedHeading: HeadingKey = 'h1';

  const handleToggleHeading = (sel: HeadingKey) => {
    console.log(sel)
    selectedHeading = sel;

    toggleBlock(editor, sel)
  }
  

  useEffect(() => {
    if (selectedFile) {
      const image: CustomElement = { type: 'image', url: 'https://www.' + selectedFile, children: [{ text: '' }] };

      // currently, I don't know if i can get a current cursor position, so all images will be inserted at the end
      // we'll have to have a way of moving the images around afterward.
      Transforms.insertNodes(editor, image)
    }
  },[selectedFile])

  // useEffect(() => {
  //   if (selectedText && targetLink) {
  //     // the link will wrap text
  //     // if the text is already in the document, then we wrap that text, otherwise 
  //     // we introduce the link with the text embedded  
  //     //const link: CustomElement = { type: 'link', url: targetLink, children: [{ text: '' }]};
  //     wrapLink(editor, targetLink, selectedText)
  //   }
  // },[selectedText,targetLink])


  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='space-evenly'
      width='fit-content'
      bRad='1px'
      p='1px'
    >
      <Box h='60px'>
      <Flex flexDirection="row">
        <Selector
          h='25px'
          pl='1rem'
          pr='1rem'
          pt='0.25rem'
          pb='0.25rem'
          mr='0.5rem'
          mt='0.15rem'
          placeholder='paragraph'
          onChange={(e: { target: { value: string; }; }) => {
            console.log('happening?')
            handleToggleHeading(e.target.value as HeadingKey);
          }}
          {...getBlockSelectionProps(editor,selectedHeading as TextAction)}
        >
          <option key='0'>choose</option>
          {HEADING_TYPES.map((item, index) => (
            <option key={index} value={item}>{item}</option>
          ))}
        </Selector>
        {TEXT_FORMAT_OPTIONS.map(({ id, label, icon, fontSize }) => (
          <Tooltip key={id} content={label}>
          <IconButton
            w='25px' h='25px'
            bColor='#999'
            bRad='4px'
            p='2px' pt='5px' pl='5px'
            m='2px'
            label={label}
            icon={icon}
            fontSize={fontSize}
            onMouseDown={() => toggleMark(editor,id as TextFormatKey)}
            {...getMarkSelectionProps(editor,id as TextFormatKey)}
          />
          </Tooltip>
        ))}
        <Divider />
        {TEXT_BLOCK_OPTIONS.map(({ id, label, icon }) => (
          <Tooltip key={id} content={label}>
          <IconButton
            w='25px' h='25px'
            bColor='#999'
            bRad='4px'
            p='2px' pt='5px' pl='5px'
            m='2px'
            label={label}
            icon={icon}
            onMouseDown={() => toggleBlock(editor,id)}
            {...getBlockSelectionProps(editor,id)}
          />
          </Tooltip>
        ))}
        <Divider />
        <Tooltip content={INSERT_LINK_BLOCK.label}>
          <IconButton
            w='25px' h='25px'
            bColor='#999'
            bRad='4px'
            p='2px' pt='5px' pl='5px'
            m='2px'
            label={INSERT_LINK_BLOCK.label}
            icon={INSERT_LINK_BLOCK.icon}
            onMouseDown={(e: { preventDefault: () => void; }) => {
              e.preventDefault()
              setSelectedText(findSelectedText(editor) || '')
              setOpenLinkDialogue(true)
              // linkMaker may change the value of selectedText or targetLink, which is where nodes are inserted and rendered.
            }}
                
          />
        </Tooltip>
        <LinkMaker 
          openDialogue={openLinkDialogue} 
          setOpenDialogue={setOpenLinkDialogue} 
          selectedText={selectedText} 
          setSelectedText={setSelectedText} 
        />

        <Tooltip content={INSERT_IMAGE_BLOCK.label}>
          <IconButton
            w='25px' h='25px'
            bColor='#999'
            bRad='4px'
            p='2px' pt='5px' pl='4px'
            m='2px'
            label={INSERT_IMAGE_BLOCK.label}
            icon={INSERT_IMAGE_BLOCK.icon}
            onMouseDown={(e: { preventDefault: () => void; }) => {
              e.preventDefault()
              
              // activate FileUploader
              setOpenFileDialogue(true)
              // fileuploader may change the value of selectedFile, which is where nodes are inserted and rendered.
            }}
                
          />
        </Tooltip>
        <FileUploader 
          openDialogue={openFileDialogue} 
          setOpenDialogue={setOpenFileDialogue} 
          selectedFile={selectedFile} 
          setSelectedFile={setSelectedFile}
        />
      </Flex>
      </Box>
    </Box>
  );
}